import React from "react";
import LegalPage from "./LegalPage";
import data from "@content/legal/privacy.json";

const PrivacyPolicy = () => (
    <LegalPage slug="privacy-policy" data={data} crumbLabel="Privacy Policy" />
);

export default PrivacyPolicy;
